if (!customElements.get('sku-notice')) {
  class SkuNotice extends HTMLElement {
    connectedCallback() {
      const section = this.closest('[id^="shopify-section-"]');
      this.sectionId = section ? section.id.replace('shopify-section-', '') : null;
      this.dataEl = this.querySelector('.sku-notice__data');
      this.textEl = this.querySelector('.sku-notice__text');
      if (!this.dataEl || !this.textEl) return;
      try {
        this.noticeMap = JSON.parse(this.dataEl.textContent.trim());
      } catch (e) {
        this.noticeMap = {};
      }
      this._unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (this.sectionId && event.data?.sectionId !== this.sectionId) return;
        const variantId = String(event.data?.variant?.id ?? '');
        const notice = this.noticeMap[variantId] ?? '';
        if (notice) {
          this.textEl.innerHTML = notice;
          this.removeAttribute('hidden');
        } else {
          this.textEl.innerHTML = '';
          this.setAttribute('hidden', '');
        }
      });
    }
    disconnectedCallback() {
      if (typeof this._unsubscribe === 'function') this._unsubscribe();
    }
  }
  customElements.define('sku-notice', SkuNotice);
}
